module.exports = __webpack_public_path__ + "img/kubet_tab_active.647df32e.png";